const facadeOrigin = import.meta.env.VITE_FACADE_ORIGIN as string | undefined
const searchModeRaw = import.meta.env.VITE_SEARCH_MODE as string | undefined

if (!facadeOrigin) {
  throw new Error('VITE_FACADE_ORIGIN is not set. Copy .env.example to .env.local and fill in.')
}

export const config = {
  facadeOrigin: facadeOrigin.replace(/\/$/, ''),
  searchMode: (searchModeRaw === 'fts' ? 'fts' : 'hybrid') as 'fts' | 'hybrid',
  redirectUri: `${window.location.origin}/callback`,
  clientName: 'KDB Cockpit'
} as const
